// Vue
import { ref } from "vue";

// Dependencies
import { defineStore } from "pinia";

interface ModalConfirmProvider {
  // Methods
  toggleModalConfirm: (key: string) => void;
  showModalConfirm: (key: string) => boolean;
  isConfirmed: (key: string) => boolean;
  confirm: (key: string) => void;
  reset: () => void;
}

const useModalConfirm = defineStore("ModalConfirmProvider", (): ModalConfirmProvider => {
  // ///////////////////
  // Providers
  // ///////////////////

  // ///////////////////
  // Refs
  // ///////////////////

  const confirmModal = ref<string | null>(null);
  const confirmed = ref<string[]>([]);

  // ///////////////////
  // Getters
  // ///////////////////

  // ///////////////////
  // Setters
  // ///////////////////

  // ///////////////////
  // Methods
  // ///////////////////

  function toggleModalConfirm(key?: string) {
    if (confirmModal.value) {
      confirmModal.value = null;
    } else {
      confirmModal.value = key || null;
    }
  }

  function showModalConfirm(key: string) {
    return confirmModal.value === key;
  }

  function isConfirmed(key: string) {
    return confirmed.value.includes(key);
  }

  function confirm(key: string) {
    confirmed.value.push(key);
    toggleModalConfirm(key);
  }

  function reset() {
    confirmModal.value = null;
    confirmed.value = [];
  }

  // ///////////////////
  // Return
  // ///////////////////

  return {
    // Methods
    toggleModalConfirm,
    showModalConfirm,
    isConfirmed,
    confirm,
    reset,
  };
});

export default useModalConfirm;
